import React, {
	SetStateAction,
	useLayoutEffect,
	useState,
	useContext
} from 'react';
import { useTranslation } from 'react-i18next';
import { MdModeEdit, MdDelete } from 'react-icons/md';

import * as S from './styles';
import { DynamicShowCaseProps } from 'types/DynamicShowCaseProps';
import Load from 'components/Load';
import { color } from 'styles/pallete';
import { UseTranslationProps } from 'types/UseTranslationProps';
import ConfirmScreen from 'components/ConfirmScreen';
import { deleteShowCase } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { getDynamicShowCase } from 'pages/DynamicShowCase/reqs';
import LoadGeneralContext from 'context/LoadGeneralContext';

interface ListDynamicShowCaseProps {
	isLoad: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	setDynamicShowcaseToEdit: React.Dispatch<
		SetStateAction<null | DynamicShowCaseProps>
	>;
	listDynamicShowCase: DynamicShowCaseProps[];
	setListMenuItensLocation: React.Dispatch<
		React.SetStateAction<DynamicShowCaseProps[]>
	>;
	setActualPage: React.Dispatch<React.SetStateAction<number>>;
	setTotalPages: React.Dispatch<React.SetStateAction<number>>;
	actualPage: number;
}

export default function ListDynamicShowCase({
	isLoad,
	listDynamicShowCase,
	setDynamicShowcaseToEdit,
	setIsOpen,
	setActualPage,
	setListMenuItensLocation,
	setTotalPages,
	actualPage
}: ListDynamicShowCaseProps) {
	const { t }: UseTranslationProps = useTranslation();

	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [isConfirmDelete, setIsConfirmDelete] = useState(false);
	const [itemToDelete, setItemToDelete] = useState<null | DynamicShowCaseProps>(
		null
	);

	function edit(item: DynamicShowCaseProps) {
		setDynamicShowcaseToEdit(item);
		setIsOpen(true);
	}

	async function deleteItem() {
		setIsOpenLoad(true);
		setMessage('Deletando vitrini dinâmica');

		const resp = await deleteShowCase(itemToDelete?.id || '', handleNotify);

		if (resp.isSuccess && itemToDelete !== null) {
			const actualPageRefreshed =
				listDynamicShowCase.length > 1 && actualPage > 1
					? actualPage
					: actualPage - 1;

			await getDynamicShowCase(
				setListMenuItensLocation,
				setActualPage,
				setTotalPages,
				actualPageRefreshed === 0 ? 1 : actualPageRefreshed,
				handleNotify
			);

			setMessage('Atualizando lista');
			setIsConfirmDelete(false);
			setItemToDelete(null);
			setIsOpenLoad(false);
		} else {
			setIsOpenLoad(false);
		}
	}

	//reseta o setItemToDelete toda vez q a tela de confirmação é fechada
	useLayoutEffect(() => {
		if (!isConfirmDelete) {
			setItemToDelete(null);
		}
	}, [isConfirmDelete]);

	return (
		<S.container>
			{isLoad ? (
				<S.centralize>
					<Load
						text={t('dynamicShowCase.listDynamicShowCase.loadShowCase')}
						showText
					/>
				</S.centralize>
			) : (
				<>
					{!isLoad && listDynamicShowCase.length === 0 ? (
						<S.centralize>
							<S.noUsers>
								{t('dynamicShowCase.listDynamicShowCase.noShowcase')}
							</S.noUsers>
						</S.centralize>
					) : (
						<>
							<S.header>
								<p>{t('dynamicShowCase.listDynamicShowCase.page')}</p>
								<p>Query</p>
								<p>{t('dynamicShowCase.listDynamicShowCase.isVisiable')}</p>
								<p>{t('dynamicShowCase.listDynamicShowCase.actions')}</p>
							</S.header>
							<S.line />
							<S.list>
								{listDynamicShowCase.map((item) => (
									<React.Fragment key={item.id}>
										<S.itemList>
											<p>{item.name}</p>
											<p>{item.vtex_query}</p>
											<p>
												{item.show_tab_bar
													? t('dynamicShowCase.listDynamicShowCase.yes')
													: t('dynamicShowCase.listDynamicShowCase.no')}
											</p>
											<S.actions>
												<MdModeEdit
													size={25}
													color={color.interface.darkgray}
													onClick={() => {
														edit(item);
													}}
												/>
												<MdDelete
													size={25}
													color={color.interface.darkgray}
													onClick={() => {
														setItemToDelete(item);
														setIsConfirmDelete(true);
													}}
												/>
											</S.actions>
										</S.itemList>
										<S.line />
									</React.Fragment>
								))}
							</S.list>
						</>
					)}
				</>
			)}

			<ConfirmScreen
				setIsOpen={setIsConfirmDelete}
				isOpen={isConfirmDelete}
				title={t('dynamicShowCase.listDynamicShowCase.confirmation')}
				message={
					<p>
						{t('dynamicShowCase.listDynamicShowCase.confirmationText')}{' '}
						<b style={{ fontFamily: 'nunito-bold' }}>{itemToDelete?.name}</b>?
					</p>
				}
				buttonClose={false}
				functionToExecOnConfirm={deleteItem}
			/>
		</S.container>
	);
}
